import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Dispatch } from 'redux';
import { AddressingActions, TimelineActions } from '../../store';
import { groupsDenormalizedSelector, playersInSiteSelector, sitesInGroupSelector } from '../../store/selectors';
import {
  ApplicationState,
  SlidePanelContent,
  SlidePanelPosition,
  SlidePanelSide
  } from '../../store/types';
import Filters, { FiltersActions, FiltersProps } from './Filters';

const mapStateToProps: MapStateToProps<FiltersProps, any, ApplicationState> = (state: ApplicationState, _) => {
  const { selectedGroup, selectedSite, selectedPlayer } = state.addressing;
  const { parentMediaId } = state.timeline;

  return {
    parentMediaId,
    groups: groupsDenormalizedSelector(state),
    sites: sitesInGroupSelector(state),
    players: playersInSiteSelector(state),
    selectedGroup,
    selectedPlayer,
    selectedSite
  };
};

const mapDispatchToProps: MapDispatchToProps<FiltersActions, any> = (dispatch: Dispatch, _) => {
  const { fetchGroupsAndSitesAsync, selectGroup, selectSite, selectPlayer } = AddressingActions;
  return {
    getGroupsAndSites: (channelId: number) => dispatch<any>(fetchGroupsAndSitesAsync(channelId)),
    selectGroup: (value: number) => dispatch<any>(selectGroup(value)),
    selectSite: (value: number) => dispatch<any>(selectSite(value)),
    selectPlayer: (value: number) => dispatch(selectPlayer(value)),
    resetFilters: (group: number, site: number, player: number) =>
      dispatch(AddressingActions.restoreFilterValues(group, site, player)),
    closeSlidePanel: () =>
      dispatch(
        TimelineActions.setSlidePanelPositionAndContent(
          SlidePanelPosition.Closed,
          SlidePanelContent.Filters,
          SlidePanelSide.Left
        )
      )
  };
};

export const FiltersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Filters);



// WEBPACK FOOTER //
// ./src/components/filters/FiltersContainer.ts